import { render, staticRenderFns } from "./Squire.vue?vue&type=template&id=5ea831f7&"
import script from "./Squire.vue?vue&type=script&lang=js&"
export * from "./Squire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports